var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmatioWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0273 55C43.8345 55 55.0273 43.8071 55.0273 30C55.0273 16.1929 43.8345 5 30.0273 5C16.2202 5 5.02734 16.1929 5.02734 30C5.02734 43.8071 16.2202 55 30.0273 55Z",
    stroke: "#EE6C4D",
    strokeWidth: 3.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0273 42.5V27.5",
    stroke: "#EE6C4D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0273 17.5C31.4081 17.5 32.5273 18.6193 32.5273 20C32.5273 21.3807 31.4081 22.5 30.0273 22.5C28.6466 22.5 27.5273 21.3807 27.5273 20C27.5273 18.6193 28.6466 17.5 30.0273 17.5Z",
    fill: "#EE6C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmatioWarningIcon);
export default __webpack_public_path__ + "static/media/confirmatio-warning-icon.37a913b8907c51ffdef7a38d8bb4c416.svg";
export { ForwardRef as ReactComponent };